<div class="footer__signature">
  <span class="footer__copyright">
    <span itemprop="copyrightYear">{{ currentYear }}</span
    >&nbsp;
    <span itemprop="copyrightHolder" itemscope itemtype="https://schema.org/Organization">
      <span itemprop="name">{{ companyName }}</span>
    </span>
  </span>
  <div class="footer__domains" *ngIf="isSsrLinkFooterOpened; else linksHome">
    <button
      *ngFor="let country of domainsLinks"
      (click)="setLanguage($event, country.mnemonic, country.link)"
      class="footer__domainsLink"
    >
      {{ country.name }}
    </button>
  </div>
  <ng-template #linksHome>
    <div class="footer__domains">
      <a
        *ngFor="let country of domainsLinks"
        href="{{ country.link }}"
        (click)="setLanguage($event, country.mnemonic, country.link)"
        class="footer__domainsLink"
        >{{ country.name }}</a
      >
    </div>
  </ng-template>
</div>
